import { Component } from '@angular/core';
import { TMAuthService } from '@fgb/core';

@Component({
  selector: 'fgbcl-tm-login-button',
  templateUrl: './tm-login-button.component.html',
  styleUrls: ['./tm-login-button.component.scss']
})
export class TmLoginButtonComponent{

  constructor(private tmOauthService: TMAuthService) { }

  public LoginToOAuthProvider(): void {
    this.tmOauthService.loginRedirect('R');
  }

}
